/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listOwnedMoneyPools} from '../api'

export const useMutationListOwnedMoneyPools = createReactQueryMutationHook('listOwnedMoneyPools', listOwnedMoneyPools)
